<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import ImportTemplate from "@/views/components/common/form/commonImportTemplate.vue";
import config from "@/../config";
import selectEdit from "./selectEdit.vue";
import detailsVue from "./details.vue";

export default {
  extends: baseList,
  components: {
    selectEdit,
    detailsVue,
  },
  data() {
    return {
      table: {
        mname: "commondescr",
        key: "id",
        url: {
          del: "/admin/system/common",
          list: "/admin/system/common/publicNotList",
        },
        output: false,
      },
      customerId: "",
      actions: [
        // {
        //     label: "新增",
        //     icon: "md-add",
        //     type: "info",
        //     onClick: this.toAdd,
        //     auth: "system/commondescr/add",
        // },
        // {
        //     label: "导入字典",
        //     icon: "md-cloud-upload",
        //     onClick: this.toImport,
        //     auth: "",
        //     type: "info",
        // },
        // {
        //     label: "下载模板",
        //     icon: "md-log-out",
        //     onClick: this.toDownload,
        //     auth: "system/commondescr/download",
        //     type: "info",
        // },
        // {
        //   label: "导出字典",
        //   icon: "md-download",
        //   type: "info",
        //   onClick: this.exportData.bind(this, "服务字典列表", 6),
        //   auth: "system/commondescr/exportData",
        // },
      ],
      menus: [
        {
          label: "知识库",
          name: "issueKnowledgeBase",
          auth: "",
        },
        {
          label: "知识库审核",
          name: "auditKnowledgeBase",
          auth: "",
        },
      ],
      // menus: [
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   // {
      //   //   label: "供应商",
      //   //   name: "supplier_main",
      //   //   auth: "system/supplier/index",
      //   // },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "型号库",
      //     name: "deviceType_list",
      //     auth: "",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   // {
      //   //   label: "巡检模板",
      //   //   name: "templateManagement_list",
      //   //   auth: "system/templateManagement/index",
      //   // },
      //   {
      //     label: "巡检类别",
      //     name: "category_list",
      //     auth: "system/category/index",
      //   },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },

      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },

      // ],
      filters: [
        {
          label: "字典内容",
          name: "descr",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          // type: "selection",
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        // {
        //   title: '类型',
        //   key: 'workType',
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.workType == 1 ? "报修内容" : ''
        //     return (
        //       <span>{text}</span>
        //     );
        //   },
        // },
        // {
        //   title: "工单类型",
        //   key: "workTypeName",
        //   minWidth: 180,
        //   minWidth: 180,
        //   align: "center",
        //   tooltip: "true",
        // },
        {
          title: "字典内容",
          minWidth: 180,
          align: "left",
          // key: "descr",
          render: (h, p) => {
            let item = p.row;
            // console.log(item);
            let directives = [
              { name: "auth", value: "system/commondescr/details" },
            ];
            return (
              <div style={{ fontSize: "16px" }}>
                <span>[{item.workTypeName}] </span>
                <span
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toDetails(item)}
                  type="default"
                  style={{ color: "#4991ff", cursor: "pointer" }}
                >
                  {" "}
                  {item.descr}
                </span>

                <span style={{ margin: "0 0 0 5px", color: "#4991ff" }}>
                  {item.state == 1 ? (
                    <span style={{ color: "#19be6b" }}>（审核通过）</span>
                  ) : item.state == 2 ? (
                    <span style={{ color: "#ed4014" }}>（审核未通过）</span>
                  ) : (
                    "（审核中）"
                  )}
                </span>

                {this.customerId == 0 ? (
                  <span
                    style={{
                      border: "none",
                      marginRight: "5px",
                      color: "#4991ff",
                      display: item.state != 3 ? "none" : "",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{ margin: "0 5px 0 5px" }}
                      onClick={() => this.toCheckData(item)}
                    >
                      通过
                    </span>
                    <span
                      style={{ color: "#ed4014" }}
                      onClick={() => this.toOutData(item)}
                    >
                      拒绝
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>
            );
          },
        },
        // {
        //   title: "审核状态",
        //   minWidth: 180,
        //   align: "left",
        //   key: "state",
        //   render: (h, params) => {
        //     const row = params.row
        //     return (
        //       <span style={{ color: "#4991ff" }}
        //       >
        //         {row.state == 1 ? '审核通过' : row.state == 2 ? '审核未通过' : '审核中'}
        //       </span>
        //     );
        //   },
        // },

        // {
        //   title: "推荐方案",
        //   key: "recommendation",
        //   minWidth: 200,
        //   align: "left",
        //   tooltip: "true",
        // },

        // {
        //   title: "操作",
        //   align: "center",
        //   minWidth: 180,
        //   key: "handle",
        //   handle: [(vm, h, currentRow, param) => {

        //     return (
        //       <Button
        //         size="small"
        //         onClick={() => this.toDetails(currentRow)}
        //         type="default"
        //         style={{ border: "none", marginRight: "5px", color: "#4991ff" }}
        //       >
        //         详情
        //       </Button>
        //     );
        //   }, (vm, h, currentRow, param) => {
        //     const row = param.row;
        //     if (this.customerId == 0) {
        //       return (
        //         <Button

        //           size="small"
        //           onClick={() => this.toCheckData(currentRow)}
        //           type="default"

        //           style={{
        //             border: "none",
        //             marginRight: "5px",
        //             color: "#4991ff",
        //             display: row.state != 3 ? "none" : "",
        //           }}
        //         >
        //           通过
        //         </Button>
        //       );
        //     }
        //   }, (vm, h, currentRow, param) => {
        //     const row = param.row;
        //     if (this.customerId == 0) {
        //       return (
        //         <Button
        //           size="small"
        //           onClick={() => this.toOutData(currentRow)}
        //           type="default"
        //           style={{
        //             border: "none",
        //             marginRight: "5px",
        //             color: "#4991ff",
        //             display: row.state != 3 ? "none" : "",
        //           }}
        //         >
        //           拒绝
        //         </Button>
        //       );
        //     }
        //   },],
        //   auth: {
        //     details: "system/commondescr/details",

        //   },
        // },
      ],
      selectListA: [],
    };
  },
  created() {
    this.customerId = window.localStorage.getItem("customerId");
    this.loadLevelDatas();
  },
  methods: {
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          this.selectListA = res.rows;
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "workTypeId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toCheckData(row) {
      this.$Modal.success({
        closable: true,
        title: "审核",
        width: "900px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <selectEdit
              row={row}
              selectListA={this.selectListA}
              onToCheckData1={(e) => this.toCheckData1(row, e)}
            ></selectEdit>
          );
        },
      });
    },

    async toCheckData1(row, id) {
      let q = {
        id: row.id,
        workTypeId: id,
        state: 1,
      };
      console.log(q);
      let res = await $utils.api.load(
        `/admin/system/common/editPublic`,
        q,
        "PUT"
      );

      this.sloading = false;
      if (res.status) {
        this.$Modal.remove();
        $utils.toast.success("保存成功");
        this.search();
      }
    },
    async toOutData(row) {
      let q = {
        id: row.id,
        state: 2,
      };
      let res = await $utils.api.load(
        `/admin/system/common/editPublic`,
        q,
        "PUT"
      );

      this.sloading = false;
      if (res.status) {
        $utils.toast.success("保存成功");
        this.search();
      }
    },

    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/common/template/download`;
    },
    toAdd() {
      $utils.url.push({
        name: "commondescr_add",
        query: { action: "add", type: 3 },
      });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commondescr_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    toDetails(currentRow) {
      let that = this;
      // console.log(currentRow);
      // $utils.url.push({
      //   name: 'knowledgeBaseDetails',
      //   query: { id: currentRow.id, type: 1 }
      // })
      let customComponent = this.$createElement(detailsVue, {
        props: {
          row: currentRow,
          type: 1,
        },
      });
      this.$drawer.show({
        visible: true,
        title: currentRow.workTypeName,
        size: "50%",
        direction: "rtl",
        content: customComponent,
        beforeClose: () => {
          // 在关闭抽屉前执行一些操作
        },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
  },
};
</script>
<style scoped></style>
